import React from 'react'
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import DialogContent from "@material-ui/core/DialogContent";
import Api from "../../helpers/Api";
import Env from "../../config/env";
import Alert from "@material-ui/lab/Alert";
import {Tab, Tabs} from "@material-ui/core";
import * as PropTypes from "prop-types";
import Icon from "@material-ui/core/Icon";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                children
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

class RespuestaSolicitud extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            respuestas: [],
            documentos: [],
            valueTab: 0,
            respuestaSelected: null,
            openDialogDetalleRespuesta: false,
        };

    }

    async componentDidMount() {
        const solicitudID = this.props.solicitudID;
        const params = `solicitud_id=${solicitudID}&notificar_usuario=${true}&mostrar_documentos=${true}`;
        const response = await Api.get(`${Env.UrlBackendCuentaNueva}/solicitud-interaccion-paso/get-all?${params}`);
        this.setState({
            respuestas: response.data,
            documentos: response.documentos
        });
    }

    handleChangeTab = (e, newValue) => {
        this.setState({
            valueTab: newValue
        })
    }

    a11yProps = (index) => {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    verDocumento = (url) => {
        window.open(Env.UrlPublicFilesCuentaNueva + url);
    }

    handleOpenDialogDetalleRespuesta = (value) => {
        this.setState({
            openDialogDetalleRespuesta: true,
            respuestaSelected: value?.descripcion
        });
    }

    handleCloseDialogDetalleRespuesta = () => {
        this.setState({
            openDialogDetalleRespuesta: false
        })
    }

    render() {

        const {onClose, solicitud} = this.props;

        return (
            <DialogContent style={{padding: '0px'}}>
                <AppBar style={{position: 'relative'}}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={onClose}
                                    aria-label="close">
                            <CloseIcon/>
                        </IconButton>
                        <Typography variant="h6">
                            <b>Gestión de la Solicitud - Radicado No. {solicitud?.radicado}</b>
                        </Typography>

                    </Toolbar>
                </AppBar>

                <div>
                    {
                        this.state.respuestas.length === 0
                            ?

                            <div style={{padding: '30px'}}>
                                <Alert severity="info">¡No se encontraron registros!</Alert>
                            </div>

                            :

                            <div>
                                <AppBar position="static" style={{background: '#e9ecef', color: '#000'}}>
                                    <Tabs value={this.state.valueTab} onChange={this.handleChangeTab}>
                                        <Tab label="Histórico" {...this.a11yProps(0)} />
                                        <Tab label="Documentos" {...this.a11yProps(1)} />
                                    </Tabs>
                                </AppBar>
                                <div style={{minHeight: '500px', height: '500px', overflowY: 'auto'}}>
                                    <TabPanel value={this.state.valueTab} index={0}>
                                        <div style={{padding: '10px'}}>
                                            <table className='custom-table'>
                                                <thead>
                                                <tr>
                                                    <th className='fixed-row'>Paso</th>
                                                    <th className='fixed-row' style={{width: '60%'}}>Descripción</th>
                                                    <th className='fixed-row'>Fecha</th>
                                                </tr>
                                                </thead>
                                                <tbody>

                                                {this.state.respuestas.map((val, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{val?.solicitud_paso?.paso?.nombre}</td>
                                                            <td>
                                                                <div>
                                                                    <div style={{
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        height: '60px',
                                                                        width: '750px'
                                                                    }}
                                                                         dangerouslySetInnerHTML={{__html: val?.descripcion}}></div>

                                                                    <div style={{textAlign: 'center'}}>
                                                                        <Button
                                                                            variant="outlined"
                                                                            color="secondary"
                                                                            size="small"
                                                                            onClick={() => {
                                                                                this.handleOpenDialogDetalleRespuesta(val);
                                                                            }}>
                                                                            Ver más
                                                                        </Button>
                                                                    </div>

                                                                </div>
                                                            </td>
                                                            <td style={{textAlign: 'center'}}>{val?.created_at}</td>
                                                        </tr>
                                                    );
                                                })}

                                                </tbody>
                                            </table>
                                        </div>
                                    </TabPanel>
                                    <TabPanel value={this.state.valueTab} index={1}>
                                        <div style={{padding: '10px'}}>
                                            {this.state.documentos.map((val, index) => {
                                                return (
                                                    <div
                                                        key={index}
                                                        style={{
                                                            marginBottom: '10px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '5px'
                                                        }}>

                                                        <h2 style={{textAlign: 'center'}}>{val?.paso?.nombre} / {val?.estado?.nombre}</h2>

                                                        <table className='custom-table'>
                                                            <thead>
                                                            <tr>
                                                                <th>Documento</th>
                                                                <th>Fecha</th>
                                                                <th>Ver</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            {val?.documentos.map((val2, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td style={{textAlign: 'center'}}>{val2?.documento?.nombre}</td>
                                                                        <td style={{textAlign: 'center'}}>{val2?.updated_at}</td>
                                                                        <td style={{textAlign: 'center'}}>
                                                                            <Tooltip title="Ver Documento">
                                                                                <IconButton color="secondary"
                                                                                            onClick={() => {
                                                                                                this.verDocumento(val2?.url_documentos)
                                                                                            }}>
                                                                                    <Icon>visibility</Icon>
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                );
                                            })}

                                        </div>
                                    </TabPanel>
                                </div>
                            </div>
                    }
                </div>


                <Dialog onClose={this.handleCloseDialogDetalleRespuesta} aria-labelledby="customized-dialog-title"
                        open={this.state.openDialogDetalleRespuesta}>

                    <DialogContent>
                        <div dangerouslySetInnerHTML={{__html: this.state.respuestaSelected}}></div>
                    </DialogContent>

                </Dialog>

            </DialogContent>
        );
    }
}

export default RespuestaSolicitud